import { createAction } from "@reduxjs/toolkit";

export const resetStore = createAction("reset/store");
